import { Web3Provider } from "@ethersproject/providers"

import { WalletType } from "./constant"

export function getLibrary(provider: any): Web3Provider {
    const library = new Web3Provider(provider, "any")
    library.pollingInterval = 15000
    return library
}
// NOTE:  The injected connector can be used for both Metamask wallet and Coinbase Wallet.
// Hence, the activateInjectedProvider function is used to select the provider (in this case Metamask)
// when using the injected connector in order to prevent double prompting of Metamask and Coinbase Wallet
// at the same time to users.
export const activateInjectedProvider = (providerName = WalletType.METAMASK) => {
    const { ethereum } = window

    if (!ethereum?.providers) {
        return undefined
    }

    let provider
    switch (providerName) {
        case WalletType.WALLETLINK_CONNECT:
            provider = ethereum.providers.find(({ isCoinbaseWallet }: any) => isCoinbaseWallet)
            break
        case WalletType.METAMASK:
            provider = ethereum.providers.find(({ isMetaMask }: any) => isMetaMask)
            break
        default:
            provider = ethereum.providers.find(({ isMetaMask }: any) => isMetaMask)
    }

    if (provider) {
        ethereum.setSelectedProvider(provider)
    }
}
